/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2022, Bulb Inc. For more information, please email contact@hellobulb.com.
*/

/**
 * Class used as a static readonly type for accessing corresponding background and text colors for dynamic avatars
 */
export class AvatarColors {
  public static readonly DEFAULT = new AvatarColors('#8D9091', '#3E4043');

  public static readonly YELLOW = new AvatarColors('#FFF799', '#5A440D');

  public static readonly RED = new AvatarColors('#F5989D', '#96223B');

  public static readonly GREEN = new AvatarColors('#20F9C4', '#00552A');

  public static readonly BLUE = new AvatarColors('#6DCFF6', '#1D5C86');

  public static readonly ORANGE = new AvatarColors('#FED099', '#551700');

  private constructor(
    public readonly background: string,
    public readonly text: string,
  ) {}
}

export type SubjectType = 'BULB_USER' | 'BULB_GROUP' | 'BULB_ORGANIZATION';

export type AvatarColor = 'YELLOW' | 'RED' | 'GREEN' | 'BLUE' | 'ORANGE';

export type DisplayProps = {
  id: string,
  subjectType: SubjectType,
  displayName: string,
  initials?: string,
  username?: string,
  colorScheme?: AvatarColor,
  avatarImage? : {
    id : string,
    assetDefinitionsKey : string,
    width : number,
    height : number,
    url : string,
    source : string,
    photographerName : string,
    photographerProfileUrl : string,
    imageId : string,
  },
};

export const AvatarColorsMapping = new Map<AvatarColor, AvatarColors>([
  ['YELLOW', AvatarColors.YELLOW],
  ['RED', AvatarColors.RED],
  ['GREEN', AvatarColors.GREEN],
  ['BLUE', AvatarColors.BLUE],
  ['ORANGE', AvatarColors.ORANGE],
]);
